import ScrollView from 'devextreme-react/scroll-view';
import type { ReactNode } from 'react';
import { hasAnyHrRole } from './roles';
import { useAuthStore } from './useAuthStore';

interface RequireHrAccessProps {
  children: ReactNode;
}

/** Gates Human Relations / Time Off routes: ItSysAdmin or OpsHRCompany or OpsHRContract. */
export function RequireHrAccess({ children }: RequireHrAccessProps) {
  const roles = useAuthStore((s) => s.roles);

  if (!hasAnyHrRole(roles)) {
    return (
      <ScrollView>
        <div style={{ padding: '2rem', maxWidth: 560 }}>
          <h2>Access denied</h2>
          <p>
            You don&apos;t have permission to view this page. Required: ItSysAdmin, OpsHRCompany, or OpsHRContract.
          </p>
        </div>
      </ScrollView>
    );
  }

  return <>{children}</>;
}
